
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as authLldLAL6sjaJfinhufTblQ2SvXbV4tXp__siTwYISsSIMeta } from "/app/pages/auth.vue?macro=true";
import { default as testWAmRdgC_JsMpRTj2Lw1hcgaT_45NU9xgELwBJuztcYPh8Meta } from "/app/pages/test.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as sitemapCc4he_452PbvShEh3JaJNYlBjcVwqvYR0QrzHKlC9YKbkMeta } from "/app/pages/sitemap.vue?macro=true";
import { default as supporta84A2tb9xESxO6bOKWmFoDLo2va0te5rR2kefeEwfjUMeta } from "/app/pages/support.vue?macro=true";
import { default as welcomeZPrEddxWJc2ey1MEbIjgSlcrr_5_45tSo_42WYcPnDwp0Meta } from "/app/pages/welcome.vue?macro=true";
import { default as theloginj9kJ8SUEC8tkNZVk5yTj8nADZ6XPZWrhPuNJ5CNcv5IMeta } from "/app/pages/thelogin.vue?macro=true";
import { default as _91_46_46_46slug_93_45LjGMcLlDIaBVlYZTrD_5xNfGo_raWjxI9Ydz2d_45OsMMeta } from "/app/pages/changelog/[...slug].vue?macro=true";
import { default as changelog_45mFataRA1iA3Fy4ui7CNtJVmMWf4oU_2_45N20Zy89Wn8Meta } from "/app/pages/changelog.vue?macro=true";
import { default as _91slug_93GAjmB1xXcnpuLj9BBisJUEqGu42zZzHy_GUJDYU3MCEMeta } from "/app/pages/game/[slug].vue?macro=true";
import { default as indexyMaKfbLH_45BfoJMK_45bFE5OpzW_CSlLFfNQy11w_qN9TUMeta } from "/app/pages/genres/index.vue?macro=true";
import { default as indexerVok6WuO_45bD_epLv11VS1IhhDyA1OkLTQzRo7VG6P0Meta } from "/app/pages/import/index.vue?macro=true";
import { default as indexKGFpJrfaPGuuhppiHh6jzgX1cc0MaKSlIxKJ_45q3hxrYMeta } from "/app/pages/account/index.vue?macro=true";
import { default as index_45YqZdB_VzlZy8_45sj5tCG87p_fqHr5B_455V1EEKSka25kMeta } from "/app/pages/journal/index.vue?macro=true";
import { default as update1bDxm3F2eBL_45EYz0JhGOORNVjctMnxRsEjmfM3FMBZgMeta } from "/app/pages/account/update.vue?macro=true";
import { default as _91_46_46_46slug_93vuj7bekBXVAzv_lMD2HQ32sJHv92_45lIceVF6RU4WMpMMeta } from "/app/pages/docs/[...slug].vue?macro=true";
import { default as indexGIg01HMusGl57fmD8a_45DzoPygQJf9hzozswEsm_45uON8Meta } from "/app/pages/community/index.vue?macro=true";
import { default as lists1QIVwIEGVcMVv2iEkxpvh0BwtGpdwXXEcjkO2YxfxnMMeta } from "/app/pages/community/lists.vue?macro=true";
import { default as _91_46_46_46slug_93_rpueBtSKc4vByzDNrOwJsATA3XmXzpuhQfwvtKakz4Meta } from "/app/pages/games/[...slug].vue?macro=true";
import { default as _91section_93SfTyIkq1AagnGdBq7_ux3N2FMBhXWphR59p21CUsH_45kMeta } from "/app/pages/account/[section].vue?macro=true";
import { default as _91platform_93ugYoJZ4aCce5wvCd9QKhWLPombUV3azEt4chlOZ0rswMeta } from "/app/pages/import/[platform].vue?macro=true";
import { default as _91_46_46_46slug_93xxRJw3ncVewZU_45ESrBHs83yAEUG3qJM2PkS0Tt4o_45wIMeta } from "/app/pages/library/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93FD5vvP5RXcgisfEUcEInPcejE_455XedlqBiNYFk0ffY0Meta } from "/app/pages/my/list/[...slug].vue?macro=true";
import { default as _91slug_93DrbcSe3LgIq5nUZlMxi6oLGer3dm2Zf1_0YnhEFwUvsMeta } from "/app/pages/@[user]/list/[slug].vue?macro=true";
import { default as metiVA3GG6UGoDMlY88AxXqFn6ti4ZA_CUOYwppYHNRkYMeta } from "/app/pages/account/sections/me.vue?macro=true";
import { default as logsh_bAGeaxSp7pPrASnOTeiQ7S2XfXhYmhmRmRQCspZ3YMeta } from "/app/pages/account/sections/logs.vue?macro=true";
import { default as listshmQH9bXYbN6SJ6OlGFfNyCqt0AiYYmWZps7mPjsnI9gMeta } from "/app/pages/account/sections/lists.vue?macro=true";
import { default as statesArXMQlS_72MQIk1D1qd_45HTtlHVzIAuwmlHQkb3o_kfIMeta } from "/app/pages/account/sections/states.vue?macro=true";
import { default as backups_45v_Ih8Opwh_75R_45MtyjTTErvnleQkB82qD16_456E5CQQMeta } from "/app/pages/account/sections/backups.vue?macro=true";
import { default as database4UqBVcTRhS7QdeyoAXJq1Mitf6dsOq_BP_yswy1fSjkMeta } from "/app/pages/account/sections/database.vue?macro=true";
import { default as communityF7q_Q8TwqlEd7yEsP13Z9yKDeS_45nTe3G_dTmL36IXKAMeta } from "/app/pages/account/sections/community.vue?macro=true";
import { default as preferencesIv8IAO8OQqbyAatjtbCTcRoWfya_45V7LrjAxrbVsB8cgMeta } from "/app/pages/account/sections/preferences.vue?macro=true";
import { default as integrationsOBKgQIBPj2juvMjHJLWT4jynwcafYpsZRsKlbQ4isYMMeta } from "/app/pages/account/sections/integrations.vue?macro=true";
export default [
  {
    name: "auth",
    path: "/auth",
    component: () => import("/app/pages/auth.vue")
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/app/pages/test.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "sitemap",
    path: "/sitemap",
    component: () => import("/app/pages/sitemap.vue")
  },
  {
    name: "support",
    path: "/support",
    component: () => import("/app/pages/support.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    meta: welcomeZPrEddxWJc2ey1MEbIjgSlcrr_5_45tSo_42WYcPnDwp0Meta || {},
    component: () => import("/app/pages/welcome.vue")
  },
  {
    name: "thelogin",
    path: "/thelogin",
    component: () => import("/app/pages/thelogin.vue")
  },
  {
    name: "changelog",
    path: "/changelog",
    component: () => import("/app/pages/changelog.vue"),
    children: [
  {
    name: "changelog-slug",
    path: ":slug(.*)*",
    component: () => import("/app/pages/changelog/[...slug].vue")
  }
]
  },
  {
    name: "game-slug",
    path: "/game/:slug()",
    component: () => import("/app/pages/game/[slug].vue")
  },
  {
    name: "genres",
    path: "/genres",
    component: () => import("/app/pages/genres/index.vue")
  },
  {
    name: "import",
    path: "/import",
    component: () => import("/app/pages/import/index.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: indexKGFpJrfaPGuuhppiHh6jzgX1cc0MaKSlIxKJ_45q3hxrYMeta || {},
    redirect: "/account/me",
    component: () => import("/app/pages/account/index.vue")
  },
  {
    name: "journal",
    path: "/journal",
    component: () => import("/app/pages/journal/index.vue")
  },
  {
    name: "account-update",
    path: "/account/update",
    meta: update1bDxm3F2eBL_45EYz0JhGOORNVjctMnxRsEjmfM3FMBZgMeta || {},
    component: () => import("/app/pages/account/update.vue")
  },
  {
    name: "docs-slug",
    path: "/docs/:slug(.*)*",
    component: () => import("/app/pages/docs/[...slug].vue")
  },
  {
    name: "community",
    path: "/community",
    component: () => import("/app/pages/community/index.vue")
  },
  {
    name: "community-lists",
    path: "/community/lists",
    component: () => import("/app/pages/community/lists.vue")
  },
  {
    name: "games-slug",
    path: "/games/:slug(.*)*",
    component: () => import("/app/pages/games/[...slug].vue")
  },
  {
    name: "account-section",
    path: "/account/:section()",
    component: () => import("/app/pages/account/[section].vue")
  },
  {
    name: "import-platform",
    path: "/import/:platform()",
    component: () => import("/app/pages/import/[platform].vue")
  },
  {
    name: "library-slug",
    path: "/library/:slug(.*)*",
    component: () => import("/app/pages/library/[...slug].vue")
  },
  {
    name: "my-list-slug",
    path: "/my/list/:slug(.*)*",
    component: () => import("/app/pages/my/list/[...slug].vue")
  },
  {
    name: "@user-list-slug",
    path: "/@:user()/list/:slug()",
    component: () => import("/app/pages/@[user]/list/[slug].vue")
  },
  {
    name: "account-sections-me",
    path: "/account/sections/me",
    component: () => import("/app/pages/account/sections/me.vue")
  },
  {
    name: "account-sections-logs",
    path: "/account/sections/logs",
    component: () => import("/app/pages/account/sections/logs.vue")
  },
  {
    name: "account-sections-lists",
    path: "/account/sections/lists",
    component: () => import("/app/pages/account/sections/lists.vue")
  },
  {
    name: "account-sections-states",
    path: "/account/sections/states",
    component: () => import("/app/pages/account/sections/states.vue")
  },
  {
    name: "account-sections-backups",
    path: "/account/sections/backups",
    component: () => import("/app/pages/account/sections/backups.vue")
  },
  {
    name: "account-sections-database",
    path: "/account/sections/database",
    component: () => import("/app/pages/account/sections/database.vue")
  },
  {
    name: "account-sections-community",
    path: "/account/sections/community",
    component: () => import("/app/pages/account/sections/community.vue")
  },
  {
    name: "account-sections-preferences",
    path: "/account/sections/preferences",
    component: () => import("/app/pages/account/sections/preferences.vue")
  },
  {
    name: "account-sections-integrations",
    path: "/account/sections/integrations",
    component: () => import("/app/pages/account/sections/integrations.vue")
  }
]